import React, { useState, type FC, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button,
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText,
  MODAL_SIZE_SM,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  SPACING_24,
  SpacingVertical,
  TEXT_VARIANT_STANDARD,
  Text,
} from 'mailup-web-components'

import { DELIVERABILITY_INDEX_TYPE_AUDIT } from 'Constants'
import { deliverabilityPendoTrack } from 'Helpers/deliverabilityIndex'
import {
  modalDeliverabilityIndexContactCancelCallback,
  modalDeliverabilityIndexContactConfirmCallback,
} from 'Pages/RecipientsList/recoil/callbacks/deliverabilityIndex'
import {
  deliverabilityIndexState,
  modalDeliverabilityIndexContactState,
} from 'Pages/RecipientsList/recoil/state/deliverabilityIndex'
import { regexEmail } from 'mailup-react-helpers'

const ModalDeliverabilityIndexContact: FC = () => {
  const intl = useIntl()
  const [isEmailValid, setIsEmailValid] = useState<boolean>(false)
  const [{ show, email }, setDeliverabilityIndexContactState] = useRecoilState(
    modalDeliverabilityIndexContactState,
  )
  const {
    AuditTip,
    ScoreData: { Score },
  } = useRecoilValue(deliverabilityIndexState)

  const handleCancel = useRecoilCallback(
    modalDeliverabilityIndexContactCancelCallback,
    [],
  )
  const handleConfirmCB = useRecoilCallback(
    modalDeliverabilityIndexContactConfirmCallback,
    [],
  )
  const handleConfirm = async (): Promise<void> => {
    deliverabilityPendoTrack(
      'Deliverability index - Warning - Sent request contact',
      DELIVERABILITY_INDEX_TYPE_AUDIT,
      AuditTip,
      Score,
    )
    await handleConfirmCB()
  }

  useEffect(() => {
    const newemail = email
    setIsEmailValid(!(newemail.match(regexEmail) === null))
  }, [email])

  const handleEmailInputChange = ({
    target: { value },
  }: {
    target: { value: string }
  }): void => {
    setDeliverabilityIndexContactState((prev) => ({
      ...prev,
      email: value,
    }))
  }

  return (
    <Modal
      show={show}
      onClose={handleCancel}
      data-mu-test="modal-deliverabilityIndex"
      size={MODAL_SIZE_SM}
      closeOnOverlayClick
      showClose
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.DeliverabilityIndex.ModalTitle',
        })}
      />

      <ModalBody>
        <Text variant={TEXT_VARIANT_STANDARD}>
          {intl.formatMessage({
            id: 'Load.DeliverabilityIndex.ModalText',
          })}
        </Text>
        <SpacingVertical variant={SPACING_24} />
        <FormElement
          labelFor="email-contact"
          label={intl.formatMessage({
            id: 'Load.DeliverabilityIndex.ModalEmailLabel',
          })}
          required
          variant={!isEmailValid ? 'danger' : undefined}
          feedback={
            !isEmailValid
              ? intl.formatMessage({ id: 'Load.MailupCommon.EmptyEmail' })
              : undefined
          }
        >
          <InputText
            id="email-contact"
            onChange={handleEmailInputChange}
            value={email}
            variant={!isEmailValid ? INPUT_TEXT_VARIANT_DANGER : undefined}
          />
        </FormElement>
      </ModalBody>
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test="cancel"
          onClick={handleCancel}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          data-mu-test={`deliverabilityIndex-warning-buyClick-Audit--${AuditTip}-confirm`}
          onClick={handleConfirm}
          disabled={!isEmailValid}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Send' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalDeliverabilityIndexContact
